export default "__VITE_ASSET__DF1A69YX__"